/**
 * @generated SignedSource<<c10c22276762481da910775a6c143f1b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type LessonSkillsFilterInput = {
  isActive?: boolean | null | undefined;
  lessonNames?: ReadonlyArray<string | null | undefined> | null | undefined;
  lessonTypeIds?: ReadonlyArray<string> | null | undefined;
  skillId?: string | null | undefined;
};
export type SkillResourceGetLessonsQuery$variables = {
  input: LessonSkillsFilterInput;
};
export type SkillResourceGetLessonsQuery$data = {
  readonly lessonSkills: {
    readonly nodes: ReadonlyArray<{
      readonly lesson: {
        readonly id: string;
        readonly name: string | null | undefined;
        readonly spanishUrl: string | null | undefined;
        readonly summary: string | null | undefined;
        readonly url: string | null | undefined;
      } | null | undefined;
    }> | null | undefined;
  } | null | undefined;
};
export type SkillResourceGetLessonsQuery = {
  response: SkillResourceGetLessonsQuery$data;
  variables: SkillResourceGetLessonsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "filter",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "LessonNode",
  "kind": "LinkedField",
  "name": "lesson",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "summary",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "spanishUrl",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SkillResourceGetLessonsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "LessonSkillNodeConnection",
        "kind": "LinkedField",
        "name": "lessonSkills",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "LessonSkillNode",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SkillResourceGetLessonsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "LessonSkillNodeConnection",
        "kind": "LinkedField",
        "name": "lessonSkills",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "LessonSkillNode",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "7fbbdf48b506ab8348383a1cab39467b",
    "id": null,
    "metadata": {},
    "name": "SkillResourceGetLessonsQuery",
    "operationKind": "query",
    "text": "query SkillResourceGetLessonsQuery(\n  $input: LessonSkillsFilterInput!\n) {\n  lessonSkills(filter: $input) {\n    nodes {\n      lesson {\n        id\n        name\n        url\n        summary\n        spanishUrl\n      }\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "62e70103d8975c1fccd87d89b79b0b98";

export default node;
